import type { Signal } from '@preact/signals-react';
import type { DynamicFormParentFieldValue } from '../../dynamic-form/dynamic-form.interfaces';
import OdinController from '../../dynamic-form/odin-controller.component';
import OdinDateCompetency from './date-competency.component';
import type { HfDateTimeProps } from './hf-date-time.component';

export interface HfDateDependableProps extends HfDateTimeProps {
  parentValue?: Signal<Array<DynamicFormParentFieldValue>>;
}

export default function HfDateCompetency({
  control,
  name,
  label,
  readOnly,
  required,
  onChange,
  fieldValueConverter,
  disabled,
  parentValue,
  currentTimeBtn,
  labelStyles,
}: HfDateDependableProps) {
  return (
    <OdinController
      name={name}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <OdinDateCompetency
          label={label}
          value={value}
          error={error?.message}
          onChange={onChange}
          readOnly={readOnly}
          required={required}
          disabled={disabled}
          parentValue={parentValue}
          currentTimeBtn={currentTimeBtn}
          labelStyles={labelStyles}
        />
      )}
    />
  );
}
